import makeStyles from '@material-ui/core/styles/makeStyles.js';

const useStyles = makeStyles({
  main: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
});

export default useStyles;
